<mat-grid-list
  cdkDropListGroup
  [cols]="screenOrientation === 'portrait' ? rows : cols"
  snPlayerGroup="cameraGrid"
  (snPlayerGroupInit)="onPlayerGroupInit($event)"
  rowHeight="fit"
  gutterSize="4px"
>
  <mat-grid-tile
    *ngFor="let camera of displayedCameras; trackBy: trackCamera; let index = index"
    [colspan]="index === 0 ? 2 : 1"
    [rowspan]="index === 0 ? 2 : 1"
    [class.empty]="!camera"
  >
    <ng-template [ngIf]="camera?.isLive || camera?.isAxonCamera" [ngIfElse]="empty">
      <div
        cdkDropList
        [cdkDropListData]="index"
        (cdkDropListDropped)="onDragDropped($event)"
        [@snFadeIn]
        [@snFadeOut]
      >
        <div class="item" cdkDrag [cdkDragData]="index">
          <div class="camera-player">
            <div class="camera-desc fs-text-truncate" cdkDragHandle>
              <sn-icon>drag_indicator</sn-icon>
            </div>
            <sn-camera-stream-view
              *ngIf="!camera.isAxonCamera"
              [camera]="camera"
              [controls]="true"
              [autoplay]="autoplay"
              [allowTimeout]="allowTimeout"
              [hoverActions]="true"
              [operationalActions]="true"
              [actions]="false"
              (streamPlay)="onCameraStreamPlay($event, camera)"
              (streamPause)="onCameraStreamPause(camera)"
              (streamStop)="onCameraStreamStop(camera)"
              (cameraSelect)="onCameraSelected($event, camera)"
            >
            </sn-camera-stream-view>
            <fs-axon-livestream-iframe
              class="axonLiveStream"
              *ngIf="camera.isAxonCamera"
              [device]="camera.axonDevice"
              [isDocked]="false"
            ></fs-axon-livestream-iframe>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #empty>
      <div class="item empty">{{ index + 1 }}</div>
    </ng-template>
  </mat-grid-tile>
</mat-grid-list>
<div *ngIf="!isSessionActive" class="gridSessionEnded">
  <p>{{ 'common.streamTimedOut' | t }}</p>
  <button mat-flat-button color="accent" (click)="reinitialize()">{{ 'common.reload' | t }}</button>
</div>

<div class="controls" *ngIf="!hideBottom">
  <button mat-button (click)="prevPage()" [disabled]="!hasPrevPage()">
    <sn-icon>navigate_before</sn-icon>
    <mat-label>{{ 'common.prevPage' | t }}</mat-label>
  </button>
  <button mat-icon-button (click)="playAll()" *ngIf="!isPlaying">
    <sn-icon>play_arrow</sn-icon>
  </button>
  <button mat-icon-button (click)="pauseAll()" *ngIf="isPlaying">
    <sn-icon>pause</sn-icon>
  </button>
  <button mat-button (click)="nextPage()" [disabled]="!hasNextPage()">
    <mat-label>{{ 'common.nextPage' | t }}</mat-label>
    <sn-icon>navigate_next</sn-icon>
  </button>
</div>
